package com.gsb.vyapar.bhagya.presentation.common.text

import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp
import com.gsb.vyapar.bhagya.theme.*

@Composable
fun TextRegular(text: String, color: Color, fontSize: TextUnit, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = fontSize,
            fontFamily = interRegular(),
            fontWeight = FontWeight(400),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun TextRegularB(text: String, color: Color, fontSize: TextUnit, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = fontSize,
            fontFamily = interRegular(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun TextMedium(text: String, color: Color, fontSize: TextUnit, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = fontSize,
            fontFamily = interMedium(),
            fontWeight = FontWeight(500),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun TextMediumI(text: String, color: Color, fontSize: TextUnit, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = fontSize,
            fontFamily = interItalic(),
            fontWeight = FontWeight(500),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun TextSemiBold(text: String, color: Color, fontSize: TextUnit, modifier: Modifier = Modifier, onClick: () -> Unit = {}) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = fontSize,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun Text11Regular(text: String, color: Color, modifier: Modifier = Modifier) {
    TextRegular(
        text = text,
        color = color,
        fontSize = 11.sp,
        modifier = modifier,
    )
}

@Composable
fun Text12Regular(text: String, color: Color, modifier: Modifier = Modifier) {
    TextRegular(
        text = text,
        color = color,
        fontSize = 12.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14Regular(text: String, color: Color, modifier: Modifier = Modifier) {
    TextRegular(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14RegularS(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 14.sp,
            fontFamily = interRegular(),
            fontWeight = FontWeight(400),
            textAlign = TextAlign.Start,
            modifier = modifier,
        )
    }
}

@Composable
fun Text16Regular(text: String, color: Color, modifier: Modifier = Modifier) {
    TextRegular(
        text = text,
        color = color,
        fontSize = 16.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14RegularB(text: String, color: Color, modifier: Modifier = Modifier) {
    TextRegularB(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14RegularBB(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14RegularBBStart(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 14.sp,
            fontFamily = interRegular(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Start,
            modifier = modifier,
        )
    }
}

@Composable
fun Text14RegularBBS(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 14.sp,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Start,
            modifier = modifier,
        )
    }
}

@Composable
fun Text14Medium(text: String, color: Color, modifier: Modifier = Modifier) {
    TextMedium(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14MediumI(text: String, color: Color, modifier: Modifier = Modifier) {
    TextMediumI(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text16Medium(text: String, color: Color, modifier: Modifier = Modifier) {
    TextMedium(
        text = text,
        color = color,
        fontSize = 16.sp,
        modifier = modifier,
    )
}

@Composable
fun Text11SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 11.sp,
        modifier = modifier,
    )
}

@Composable
fun Text12SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 12.sp,
        modifier = modifier,
    )
}

@Composable
fun Text14SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 14.sp,
        modifier = modifier,
    )
}

@Composable
fun Text16SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 16.sp,
        modifier = modifier,
    )
}

@Composable
fun Text24SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    TextSemiBold(
        text = text,
        color = color,
        fontSize = 24.sp,
        modifier = modifier,
    )
}

@Composable
fun Text24SemiBoldI(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 24.sp,
            fontFamily = interItalic(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}

@Composable
fun Text18SemiBold(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 18.sp,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Start,
            modifier = modifier,
        )
    }
}

@Composable
fun Text18SemiBoldI(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 18.sp,
            fontFamily = interItalic(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Start,
            modifier = modifier,
        )
    }
}

@Composable
fun Text18SemiBoldC(text: String, color: Color, modifier: Modifier = Modifier) {
    SelectionContainer {
        Text(
            text = text,
            color = color,
            fontSize = 18.sp,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight(600),
            textAlign = TextAlign.Center,
            modifier = modifier,
        )
    }
}